
// returns masked amount in string format like "$4,500.9", "$500", "$250.1", ""(empty string)
// Note: Javascript truncates last/ending zeros after decimals : "4,500.90" to "4,500.9" or "500.00" to "500" or "250.10" to "25.1"

const MaskAmount = (e) => {
    let value = e;
    if (value !== '') {
        value = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
        e = value;
    } else {
        e = ''
    }
    return e;
};

export default MaskAmount;